<template>
  <transition name="el-fade-in-linear">
    <el-row>
      <!---->
      <el-row>
        <div class="my-middle">
          <h2>代印服务</h2>
          <br>
          <el-button
            style="width:120px;height:55px;padding-top:10px"
            type="primary"
            :icon="同人收藏本icon"
            @click="ShowCollections(0, product)"
          >同人收藏本</el-button>
          <el-button
            style="width:120px;height:55px;padding-top:10px"
            type="primary"
            @click="ShowCollections(1, product)"
            :icon="同人周边icon"
          >同人周边</el-button>
        </div>
        <transition name="el-fade-in-linear">
          <el-alert
            title="请根据您的情况选择所需的服务"
            type="info"
            v-if="!(product.DojinCollection||product.DojinPeripheral)"
            show-icon
            class="el-alert__title"
            style="padding: 8px 16px; margin:auto; margin-top: 25px; width:560px; height:34px; "
          ></el-alert>
        </transition>
      </el-row>
      <div>
        <el-row type="flex" class="row-bg" justify="space-around" style="padding-top: 50px;">
          <el-col :span="24" style="padding: 3%; width: 100%">
            <el-collapse
              v-model="forcollapse"
              wtfname="formActive"
              style="border-top: 1px solid #CDCDCD;"
            >
              <transition name="el-fade-in-linear">
                <div>
                  <!--同人收藏本-->
                  <DojinCollection
                    v-if="product.DojinCollection"
                    v-on:service-choice-data="allData = $event"
                  />
                  <!--同人周邊-->
                  <DojinPeripheral
                    v-if="product.DojinPeripheral"
                    v-on:service-choice-data="allData = $event"
                  />
                </div>
              </transition>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </el-row>
  </transition>
</template>
<script>
import DojinCollection from "./DojinCollection.vue";
import DojinPeripheral from "./DojinPeripheral.vue";

export default {
  data() {
    return {
      forcollapse: ["同人收藏本", "同人周边"],
      product: {
        DojinCollection: false, //同人收藏本
        DojinPeripheral: false //同人周邊
      },
      formActive: ["thePrintTableData", "1", "2"], //['1']
      allData: {},
      同人收藏本icon: "el-icon-error",
      同人周边icon: "el-icon-error"
    };
  },
  name: "Agency",
  components: {
    DojinCollection,
    DojinPeripheral
  },
  methods: {
    ShowCollections: function(mode, product) {
      if (!mode) {
        product.DojinCollection = !product.DojinCollection;
        if (product.DojinCollection) {
          this.同人收藏本icon = "el-icon-success";
        } else {
          this.同人收藏本icon = "el-icon-error";
        }
      } else {
        product.DojinPeripheral = !product.DojinPeripheral;
        if (product.DojinPeripheral) {
          this.同人周边icon = "el-icon-success";
        } else {
          this.同人周边icon = "el-icon-error";
        }
      }
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
